import classNames from "classnames";
import React from "react";

import Icon from "@components/atoms/Icon";

import { IconName } from "@const/enum";

interface IProps {
  onClick: () => void;
  name: string;
  className?: string;
  isSelected?: boolean;
  isAccount?: boolean;
  isHorizontal?: boolean;
}

function TabSelector({
  className,
  onClick,
  name,
  isSelected = false,
  isAccount = false,
  isHorizontal = false,
}: IProps) {
  return (
    <li
      className={classNames(
        "group flex w-fit cursor-pointer items-center",
        isHorizontal ? "px-2.5 first:pl-0" : "",
        className,
      )}
      onClick={onClick}
      role="presentation"
    >
      <Icon
        className={classNames("hidden pc:group-hover:inline-block", isSelected && "inline-block!")}
        name={IconName.Default_700}
      />
      {isAccount ? (
        <span className="h-4.5 whitespace-nowrap">{name}</span>
      ) : (
        <span
          className={classNames(
            "h-4.5	 whitespace-nowrap text-secondary group-hover:text-primary",
            isSelected && "text-primary!",
          )}
        >
          {name}
        </span>
      )}
    </li>
  );
}

export default TabSelector;
